//React
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";

//Libs
import { Button, Icon } from "semantic-ui-react";
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../../services/apis";
import { systemLogs } from "../../../../../services/system_logs";
import { useRouter } from "../../../../../hooks/router";

//Components
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loader from "../../../../../components/Loader";
import Loading from "../../../../../components/Loading";

import * as yup from "yup";

//Styles
import {
  Container,
  QuestaoContainer,
  OpcaoContainer,
  SaveContainer,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  SemanticTable,
  HorizontalContainer,
  Fieldset,
  SubTitle,
} from "./styles";
import TextEditor from "../../../../../components/Admin/StatefulTextEditor";
import { generateJSID } from "../../../../../utils/Utils";
import ReactHtmlParser from "react-html-parser";

const EditarTesteResultado = () => {
  const [pessoa, setPessoa] = useState(null);
  const [curso, setCurso] = useState(null);
  const [modulo, setModulo] = useState(null);
  const [licao, setLicao] = useState(null);
  const [teste, setTeste] = useState(null);

  const router = useRouter();

  const initialLoad = useCallback(async () => {
    const { id_teste_resultado } = router.query;

    try {
      const { testeResultado } = (
        await api.get(`admin/testes-resultado/${id_teste_resultado}`)
      ).data;

      const teste = {
        titulo: testeResultado.teste.titulo,
        percent: testeResultado.percent,
        questoes: testeResultado.teste.json.questoes.map((questao) => ({
          ...questao,
          choice: testeResultado.json.find(
            (resposta) => resposta.pergunta_js_id === questao.id
          )?.choice,
        })),
      };

      console.log("TESTE FORMATADO:::", teste);

      setPessoa(testeResultado.pessoa);
      setCurso(testeResultado.curso);
      setModulo(testeResultado.licao.modulo);
      setLicao(testeResultado.licao);
      setTeste(teste);
    } catch (err) {
      swal("Erro", "Erro ao carregar teste", "error");
    }
  }, [router]);

  useEffect(() => {
    initialLoad();
  }, [router]);

  if (!teste) {
    return null;
  }

  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Respostas do "Consolidando Conhecimento"</Title>

        <Fieldset>
          <label>Pessoa</label>

          <Input placeholder="Nome da pessoa" value={pessoa?.nome} />
        </Fieldset>

        <Fieldset>
          <label>Curso</label>

          <Input placeholder="Titulo do Curso" value={curso?.curso} />
        </Fieldset>

        <Fieldset>
          <label>Módulo</label>

          <Input placeholder="Titulo do Módulo" value={modulo?.titulo} />
        </Fieldset>

        <Fieldset>
          <label>Lição</label>

          <Input placeholder="Titulo da Lição" value={licao?.titulo} />
        </Fieldset>

        <SubTitle>Teste</SubTitle>

        <label>
          <strong>Nota:</strong> {teste.percent}%
        </label>

        {teste.questoes.map((questao, questaoIndex) => (
          <QuestaoContainer>
            <p>
              {questaoIndex + 1}) {ReactHtmlParser(questao.pergunta)}
            </p>
            {questao.opcoes ? (
              <>
                {questao.opcoes.map((opcao, opcaoIndex) => (
                  <OpcaoContainer
                    backgroundColor={
                      opcao.isAnswer
                        ? questao.choice === opcaoIndex
                          ? "green"
                          : "red"
                        : null
                    }
                  >
                    <input
                      type="radio"
                      checked={questao.choice === opcaoIndex}
                    />
                    <Input
                      placeholder="Enunciado da Questão"
                      value={opcao.texto}
                    />
                  </OpcaoContainer>
                ))}
              </>
            ) : (
              <TextEditor default={questao.choice} />
            )}
          </QuestaoContainer>
        ))}
      </Content>
    </Container>
  );
};

export default EditarTesteResultado;
